import { ElectricMeter } from '@shared/models/electric-meter';
import { IReading, Reading } from '@shared/models/electric-meter-reading';

export function resolveElectricMeterId(
    reading?: IReading | Reading | null,
    electricMeter?: ElectricMeter | null,
    routeElectricMeterId?: string | number | null,
): number | null {
    if (electricMeter?.id != null) {
        return Number(electricMeter.id);
    }

    const readingMeterId = reading?.bcm_electric_meters_id
        ?? (reading as Reading | undefined)?.electricMeter?.id;
    if (readingMeterId != null) {
        return Number(readingMeterId);
    }

    if (routeElectricMeterId != null && routeElectricMeterId !== '') {
        return Number(routeElectricMeterId);
    }

    return null;
}
